<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<section class="checkout-section">
  <div class="container">
    <h1 class="checkout-title">{{ "page.order.checkout.title" | translate }}</h1>

    <!-- Add/Edit User Addresses -->
    <div #addAddress *ngIf="addressFormVisible" class="address-form" [class.section-highlight]="highlightedSection === 'addressForm'">
      <div class="section-header">
        <h3>
          {{ isEditing ? ("page.order.checkout.newAddress.editTitle" | translate) : ("page.order.checkout.newAddress.title" | translate) }}
        </h3>
        <button class="close-btn" (click)="closeAddressForm()">×</button>
      </div>
      <div
        class="info-banner"
        *ngIf="isEditing && editingAddressId && this.selectedAddress?.id === editingAddressId && this.billingAddressId === editingAddressId"
      >
        <mat-icon>warning</mat-icon>
        <span>{{ "page.order.checkout.newAddress.sharedEditWarning" | translate }}</span>
      </div>

      <form [formGroup]="addressForm" class="form-grid">
        <div class="form-group">
          <input type="text" class="form-input" [placeholder]="'form.street' | translate" formControlName="street" />
          <div class="error-message" *ngIf="addressForm.controls.street.touched && addressForm.controls.street.errors?.['required']">
            <span>{{ "page.login.error.required" | translate }} </span>
          </div>
        </div>

        <div class="form-group">
          <input type="text" class="form-input" [placeholder]="'form.number' | translate" formControlName="number" />
          <div class="error-message" *ngIf="addressForm.controls.number.touched && addressForm.controls.number.errors?.['required']">
            <span>{{ "page.login.error.required" | translate }} </span>
          </div>
        </div>

        <div class="form-group">
          <input type="text" class="form-input" [placeholder]="'form.city' | translate" formControlName="location" />
          <div class="error-message" *ngIf="addressForm.controls.location.touched && addressForm.controls.location.errors?.['required']">
            <span>{{ "page.login.error.required" | translate }} </span>
          </div>
        </div>

        <div class="form-group">
          <input type="text" class="form-input" [placeholder]="'form.postalCode' | translate" formControlName="postalCode" />
          <div
            class="error-message"
            *ngIf="addressForm.controls.postalCode.touched && addressForm.controls.postalCode.errors?.['required']"
          >
            <span>{{ "page.login.error.required" | translate }} </span>
          </div>
        </div>

        <div class="form-group">
          <select class="form-input" formControlName="country">
            <option *ngFor="let country of countries" [ngValue]="country.code">
              {{ country.name }}
            </option>
          </select>
          <div class="error-message" *ngIf="addressForm.controls.country.touched && addressForm.controls.country.errors?.['required']">
            <span>{{ "page.login.error.required" | translate }} </span>
          </div>
        </div>

        <label class="checkbox-label">
          <input type="checkbox" formControlName="setAsHome" />
          {{ "page.order.checkout.newAddress.subtitle" | translate }}
        </label>
      </form>

      <button class="btn-primary" (click)="saveAddress()" [disabled]="addressForm.disabled">
        {{ isEditing ? ("page.order.checkout.newAddress.update" | translate) : ("page.order.checkout.newAddress.save" | translate) }}
      </button>
    </div>

    <!-- Shipping Type Selection -->
    <div class="shipping-type-selection">
      <div class="shipping-options">
        <!-- User Addresses Choice -->
        <div class="addresses-section">
          <div #addressSection *ngIf="hasHomeShipping" class="address-section" [class.section-highlight]="highlightedSection === 'address'">
            <div class="shipping-card-header">
              <div class="shipping-card-info">
                <div class="option-icon">🏠</div>
                <div>
                  <h3>{{ "page.order.checkout.shippingType.home.title" | translate }}</h3>
                  <p>{{ "page.order.checkout.shippingType.home.subtitle" | translate }}</p>
                </div>
              </div>

              <button *ngIf="!selectingHomeAddress" class="header-btn" (click)="editHomeAddressSelection()">
                <mat-icon>edit</mat-icon>
              </button>

              <button *ngIf="selectingHomeAddress" class="header-btn" (click)="cancelHomeAddressSelection()" [disabled]="!selectedAddress">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <div *ngIf="selectingHomeAddress">
              <div class="section-header">
                <h2>{{ "page.order.checkout.shippingType.home.selectOne" | translate }}</h2>
                <button class="add-btn" [disabled]="addressFormVisible" (click)="openAddAddressForm('shipping')">
                  {{ "page.order.checkout.addNewAddress" | translate }}
                </button>
              </div>

              <!-- Address List -->
              <div *ngIf="isLoadingAddresses" class="loading">{{ "page.order.checkout.shippingType.home.loading" | translate }}</div>

              <div *ngIf="!isLoadingAddresses && addresses.length === 0" class="empty-state">
                <p>{{ "page.order.checkout.shippingType.home.empty" | translate }}</p>
              </div>

              <div class="address-list">
                <div
                  *ngFor="let address of addresses"
                  class="address-card"
                  [class.selected]="selectedAddress?.id === address.id"
                  (click)="selectAddress(address)"
                >
                  <div class="address-card-header">
                    <div class="address-info">
                      <h3>{{ address.street }} {{ address.number }}</h3>
                      <p>{{ address.postalCode }} {{ address.location }}, {{ address.country }}</p>
                      <span *ngIf="address.isHome" class="home-badge"> 🏠 </span>
                    </div>

                    <button
                      class="header-btn address-edit-btn"
                      [class.selected]="editingAddressId === address.id"
                      (click)="openEditAddressForm(address, 'shipping'); $event.stopPropagation()"
                      [attr.aria-label]="'button.edit' | translate"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!selectingHomeAddress">
              <div class="address-card address-card-summary" [class.selected]="true">
                <div class="address-card-header">
                  <div class="address-info">
                    <h3>{{ selectedAddress?.street }} {{ selectedAddress?.number }}</h3>
                    <p>{{ selectedAddress?.postalCode }} {{ selectedAddress?.location }}, {{ selectedAddress?.country }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Billing Address Selection -->
          <div #billingSection class="billing-section" [class.section-highlight]="highlightedSection === 'billing'">
            <div class="shipping-card-header">
              <div class="shipping-card-info">
                <div class="option-icon">🧾</div>
                <div>
                  <h3>{{ "page.order.checkout.billing.title" | translate }}</h3>
                </div>
              </div>

              <button *ngIf="!selectingBillingAddress" class="header-btn" (click)="editBillingAddressSelection()">
                <mat-icon>edit</mat-icon>
              </button>
              <button
                *ngIf="selectingBillingAddress"
                class="header-btn"
                (click)="cancelBillingAddressSelection()"
                [disabled]="!selectedBillingAddress && !this.useSameAsHomeForBilling"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <div>
              <div class="section-header">
                <label class="checkbox-label" *ngIf="hasHomeShipping">
                  <input
                    type="checkbox"
                    [disabled]="!selectingBillingAddress"
                    [checked]="useSameAsHomeForBilling"
                    (change)="toggleSameAsHome($any($event.target).checked)"
                  />
                  {{ "page.order.checkout.billing.sameAsShipping" | translate }}
                </label>
                <button
                  *ngIf="!useSameAsHomeForBilling && selectingBillingAddress"
                  class="add-btn"
                  [disabled]="addressFormVisible"
                  (click)="openAddAddressForm('billing')"
                >
                  {{ "page.order.checkout.addNewAddress" | translate }}
                </button>
              </div>

              <ng-container *ngIf="selectingBillingAddress">
                <!-- Address List -->
                <div *ngIf="isLoadingAddresses" class="loading">{{ "page.order.checkout.shippingType.home.loading" | translate }}</div>

                <div *ngIf="!isLoadingAddresses && addresses.length === 0" class="empty-state">
                  <p>{{ "page.order.checkout.shippingType.home.empty" | translate }}</p>
                </div>

                <div class="address-list">
                  <div
                    *ngFor="let address of addresses"
                    class="address-card"
                    [class.selected]="billingAddressId === address.id"
                    (click)="selectBillingAddress(address)"
                  >
                    <div class="address-card-header">
                      <div class="address-info">
                        <h3>{{ address.street }} {{ address.number }}</h3>
                        <p>{{ address.postalCode }} {{ address.location }}, {{ address.country }}</p>
                        <span *ngIf="address.isHome" class="home-badge"> 🏠 </span>
                      </div>
                      <button
                        class="header-btn address-edit-btn"
                        (click)="openEditAddressForm(address, 'billing'); $event.stopPropagation()"
                        [attr.aria-label]="'button.edit' | translate"
                      >
                        <mat-icon>edit</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>

            <ng-container *ngIf="!selectingBillingAddress">
              <div *ngIf="useSameAsHomeForBilling && selectedAddress" class="address-card address-card-summary" [class.selected]="true">
                <div class="address-card-header">
                  <div class="address-info">
                    <h3>{{ selectedAddress.street }} {{ selectedAddress.number }}</h3>
                    <p>{{ selectedAddress.postalCode }} {{ selectedAddress.location }}, {{ selectedAddress.country }}</p>
                  </div>
                </div>
              </div>

              <div *ngIf="!useSameAsHomeForBilling" class="address-card address-card-summary" [class.selected]="true">
                <div class="address-card-header">
                  <div class="address-info">
                    <h3>{{ selectedBillingAddress?.street }} {{ selectedBillingAddress?.number }}</h3>
                    <p>
                      {{ selectedBillingAddress?.postalCode }} {{ selectedBillingAddress?.location }}, {{ selectedBillingAddress?.country }}
                    </p>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- Relay Points (Labs) Choice -->
        <div #labSection *ngIf="shippingSummary.labCount > 0" class="lab-section" [class.section-highlight]="highlightedSection === 'lab'">
          <div class="shipping-card-header">
            <div class="shipping-card-info">
              <div class="option-icon">📍</div>
              <div>
                <h3>{{ "page.order.checkout.shippingType.relay.title" | translate }}</h3>
                <p>{{ "page.order.checkout.shippingType.relay.subtitle" | translate }}</p>
              </div>
            </div>

            <button *ngIf="!selectingRelayPoint" class="header-btn" (click)="editRelayPointSelection()">
              <mat-icon>edit</mat-icon>
            </button>

            <button *ngIf="selectingRelayPoint" class="header-btn close" (click)="cancelRelayPointSelection()" [disabled]="!selectedLab">
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <div *ngIf="selectingRelayPoint">
            <div class="section-header">
              <h2>{{ "page.order.checkout.shippingType.relay.selectOne" | translate }}</h2>
            </div>

            <div>
              <!-- Postal Code Search -->
              <div class="postal-search-container">
                <p class="search-instruction">{{ "page.order.checkout.shippingType.relay.enterPostalCode" | translate }}</p>
                <div class="search-input-group">
                  <input
                    type="text"
                    class="postal-input"
                    placeholder="e.g., 4000"
                    [(ngModel)]="postalCodeSearch"
                    (keyup.enter)="searchLabsByPostalCode()"
                  />
                  <button class="search-btn" (click)="searchLabsByPostalCode()">🔍 {{ "common.search" | translate }}</button>
                  <button *ngIf="searchedLab" class="clear-btn" (click)="clearLabSearch()">{{ "common.clear" | translate }}</button>
                </div>
              </div>

              <!-- Map -->
              <div class="map-container" [class.has-results]="showLabList">
                <app-map
                  [markers]="[]"
                  [height]="'400px'"
                  [zoom]="8"
                  [latitude]="mapDefaultLat"
                  [longitude]="mapDefaultLng"
                  [showMainMarker]="false"
                  (markerIdClick)="onMarkerIdClicked($event)"
                ></app-map>
              </div>

              <!-- Lab List -->
              <div *ngIf="showLabList" class="lab-list">
                <div class="lab-list-header">
                  <h3 *ngIf="labs.length === 0">
                    {{ "page.order.checkout.shippingType.relay.empty" | translate }}
                  </h3>
                  <h3 *ngIf="labs.length > 0">
                    {{ "page.order.checkout.shippingType.relay.found" | pluralTranslate: labs.length }}
                  </h3>
                </div>
                <div *ngIf="labs.length > 0" class="lab-grid" #labGrid>
                  <div
                    *ngFor="let lab of labs"
                    #labCard
                    class="lab-card"
                    [class.selected]="selectedLab?.identifier?.value === lab.identifier.value"
                    (click)="selectLab(lab, true)"
                  >
                    <div class="lab-card-header">
                      <div class="lab-info">
                        <h3>{{ lab.name }}</h3>
                        <p>{{ lab.street }} {{ lab.number }}</p>
                        <p>{{ lab.postalCode }} {{ lab.city }}, {{ lab.country }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Empty state when no search performed -->
              <div *ngIf="!showLabList" class="search-prompt">
                <div class="prompt-icon">📍</div>
                <p>{{ "page.order.checkout.shippingType.relay.enterPostalCode" | translate }}</p>
              </div>
            </div>
          </div>
          <div *ngIf="!selectingRelayPoint">
            <div class="lab-card lab-card-summary" [class.selected]="true">
              <div class="lab-card-header">
                <div class="lab-info">
                  <h3>{{ selectedLab?.name }}</h3>
                  <p>{{ selectedLab?.street }} {{ selectedLab?.number }}</p>
                  <p>{{ selectedLab?.postalCode }} {{ selectedLab?.city }}, {{ selectedLab?.country }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Shipping Method Selection per item -->
    <div class="checkout-item" *ngFor="let item of realCartItems">
      <div class="item-header">
        <h3>{{ item.name }}</h3>

        <div class="item-price">
          <span class="price">
            {{ item.pricePerUnit.value | minorUnitCurrency: item.pricePerUnit.currency }}
          </span>
          <span *ngIf="item.pricePerUnit.timing" class="subscription-badge">
            {{ "page.order.timing." + item.pricePerUnit.timing.periodUnit | pluralTranslate: item.pricePerUnit.timing.period | lowercase }}
          </span>
        </div>
      </div>

      <div class="shipping-method" *ngIf="item.availableShippingTypes.length === 0">
        <div class="shipping-label">
          {{ "page.order.checkout.shippingType.noShipping" | translate }}
        </div>
      </div>

      <div class="shipping-method" *ngIf="item.availableShippingTypes.length > 0">
        <div class="shipping-selection">
          <div class="shipping-label">
            {{ "page.order.checkout.shippingType.availableMethods" | translate }}
          </div>
          <div class="shipping-buttons">
            <button
              *ngIf="item.availableShippingTypes.includes(ShippingType.USER_ADDRESS)"
              [class.selected]="item.shippingType === ShippingType.USER_ADDRESS"
              (click)="selectItemShipping(item, ShippingType.USER_ADDRESS)"
            >
              {{ "page.order.checkout.shippingType.home.title" | translate }}
            </button>

            <button
              *ngIf="item.availableShippingTypes.includes(ShippingType.RELAY_POINT)"
              [class.selected]="item.shippingType === ShippingType.RELAY_POINT"
              (click)="selectItemShipping(item, ShippingType.RELAY_POINT)"
            >
              {{ "page.order.checkout.shippingType.relay.title" | translate }}
            </button>
          </div>
        </div>

        <div>
          <!-- User Addresses Choice -->
          <div class="shipping-selection-summary" *ngIf="item.shippingType === ShippingType.USER_ADDRESS && selectedAddress">
            <div class="address-info">
              <h3>{{ selectedAddress.street }} {{ selectedAddress.number }}</h3>
              <p>{{ selectedAddress.postalCode }} {{ selectedAddress.location }}, {{ selectedAddress.country }}</p>
            </div>
          </div>

          <!-- Relay Points (Labs) Choice -->
          <div class="shipping-selection-summary" *ngIf="item.shippingType === ShippingType.RELAY_POINT && selectedLab">
            <div class="lab-info">
              <h3>{{ selectedLab.name }}</h3>
              <p>{{ selectedLab.street }} {{ selectedLab.number }}</p>
              <p>{{ selectedLab.postalCode }} {{ selectedLab.city }}, {{ selectedLab.country }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Order Summary -->
    <div class="order-summary-checkout" *ngIf="realCartItems.length > 0">
      <h2>{{ "page.order.summary.title" | translate }}</h2>

      <div class="summary-section">
        <div class="shipping-group" *ngIf="shippingSummary.homeCount > 0">
          <h3>🏠 {{ "page.order.checkout.shippingType.home.count" | pluralTranslate: shippingSummary.homeCount }}</h3>

          <p *ngIf="selectedAddress">
            {{ selectedAddress.street }}
            {{ selectedAddress.number }}

            <br />

            {{ selectedAddress.postalCode }}
            {{ selectedAddress.location }}
          </p>
          <p *ngIf="!selectedAddress">⚠️ {{ "page.order.checkout.shippingType.home.missing" | translate }}</p>
        </div>

        <div class="shipping-group" *ngIf="shippingSummary.labCount > 0">
          <h3>🧪 {{ "page.order.checkout.shippingType.relay.count" | pluralTranslate: shippingSummary.labCount }}</h3>

          <p *ngIf="selectedLab">{{ selectedLab.name }}</p>
          <p *ngIf="!selectedLab">⚠️ {{ "page.order.checkout.shippingType.relay.missing" | translate }}</p>
        </div>

        <div class="shipping-group" *ngIf="shippingSummary.missingShippingMethod > 0">
          <h3>⚠️ {{ "page.order.checkout.shippingType.missingCount" | pluralTranslate: shippingSummary.missingShippingMethod }}</h3>
        </div>

        <div class="shipping-group" *ngIf="!billingAddressId">
          <h3>⚠️ {{ "page.order.checkout.shippingType.missingBilling" | translate }}</h3>
        </div>
      </div>

      <div class="summary-row">
        <span>{{ "page.order.summary.totalItems" | pluralTranslate: realCartItems.length }}</span>
        <span>{{ dueToday$ | async | minorUnitCurrency: realCartItems[0].pricePerUnit.currency }}</span>
      </div>
      <button class="place-order-btn" [disabled]="!canPlaceOrder" (click)="placeOrder()">
        {{ "page.order.checkout.button.title" | translate }}
      </button>
    </div>
  </div>
</section>
